import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuditPanel } from './auditPanelStore';
import { useAudit } from './hooks';
// Legacy flat /delivery/audits/:id deep links. The audit is the PANEL now —
// there is no detail page — so a surviving link opens the panel and lands on
// the owning program's audits page (the panel's natural backdrop). A missing
// audit falls back to the programs list.
export function AuditLegacyRedirect() {
    const { id } = useParams();
    const { data: audit, isLoading } = useAudit(id ?? '');
    const open = useAuditPanel((s)=>s.open);
    useEffect(()=>{
        if (audit?.id) open(audit.id);
    }, [
        audit?.id,
        open
    ]);
    if (isLoading) return null;
    if (!audit) return /*#__PURE__*/ _jsx(Navigate, {
        to: "/delivery/programs",
        replace: true
    });
    return /*#__PURE__*/ _jsx(Navigate, {
        to: `/delivery/programs/${audit.programId}/audits`,
        replace: true
    });
}
